import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const TAILORING_FROM_PUBLIC_JOB_BOARD_HEADER_HEIGHT = 72

export const Container = styled.div`
  height: ${TAILORING_FROM_PUBLIC_JOB_BOARD_HEADER_HEIGHT}px;
  background-color: ${Colors.White};
  border-bottom: 1px solid ${Colors.Neutral15};
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  padding: 0 32px;
`

export const BackIcon = styled.div`
  display: inline-block;
  margin: 24px 0;
  z-index: 1;
  cursor: pointer;
  & svg {
    transform: rotate(180deg);
  }
  & path {
    stroke: ${Colors.Neutral50};
  }
`
export const Center = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${TAILORING_FROM_PUBLIC_JOB_BOARD_HEADER_HEIGHT}px;
`

export const Title = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
`

export const Step = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const WrapperStartTailoringButton = styled.div`
  margin: 12px 0;
  display: flex;
  gap: ${Spacing.S};
  ${Media.Phone`display: none;`}
`
